import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRotate as spinner } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import './Loader.css';

const Loader = () => {
	const { t } = useTranslation();

	return (
		<div className='Loader'>
			<FontAwesomeIcon icon={spinner} className='icon fa-spin' size='lg'/>
			{t('common.loading')}
		</div>
	);
};

export default Loader;
